module.exports = __webpack_public_path__ + "img/wdyhq.97a85d04.png";